<template>
  <div>
      <v-card>

      </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    group_code: String
  },
  data() {
    return {
        group_info: null,
      //   tt_list: null,
      //   slots: null,
      //   slot_type: null,
      //   faculty: null,
      //   tt_load: false,
      //   dis_ay: null,
      //   faculty_name: ""
    };
  },
  watch: {
    group_code() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const formData = {
        group_code: this.group_code
      };
      axios
        .post("/CommunicationGroup/addMemberUsingCode", formData)
        .then(res => {
          console.log(res.data);
          if (res.data.status == "YES") {
            alert(res.data.status);
            // this.tt_list = res.data.tt_list;
            // this.slots = res.data.slot;
            // this.slot_type = res.data.slot_type;
            // this.faculty = res.data.faculty;
            // this.dis_ay = res.data.ay;
            // this.faculty_name = res.data.faculty_name;
          } else {
            alert(res.data.status);
          }
        })
        .catch(error => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          //stop loader
          //   this.tt_load = false;
        });
    }
  }
};
</script>